import { IRoundTeesAssignation } from '../store';

import api, { request } from '../../../api';
import { IStore } from '../../index';

const updateRoundTee = async (
  state: IStore,
  clubId: number,
  eventId: number,
  roundId: number,
  roundTeeAssignation: IRoundTeesAssignation
) => {
  const assignation = {
    ...roundTeeAssignation,
    tee: roundTeeAssignation.tee ? roundTeeAssignation.tee.id : null
  };

  delete assignation.flight;

  const response = await request.put(
    api.roundTee(clubId, eventId, roundId, assignation.id),
    assignation
  );

  const otherAssignations = state.roundTees.assignation.filter(
    assignatin => assignatin.id !== roundTeeAssignation.id
  );

  return response.errors
    ? { error: { roundTees: 'The assignation could not be made' } }
    : { roundTees: { assignation: [...otherAssignations, roundTeeAssignation] } };
};

export default updateRoundTee;
